import React from "react"
import PropTypes from "prop-types"

import { ScrollFrameFooter } from "ui-ScrollFrame"
import CardActions from '@material-ui/core/CardActions';

const styleSheet = theme => ({
  root: {
    paddingLeft: theme.spacing.unit * 4,
    paddingRight: theme.spacing.unit * 4,
    paddingBottom: theme.spacing.unit,

    [theme.breakpoints.down("xs")]: {
      paddingLeft: theme.spacing.unit * 2,
      paddingRight: theme.spacing.unit * 2,
    },
  },

  actions: {
    justifyContent: "flex-end",
  },

  gutterTop: {
    paddingTop: theme.spacing.unit * 3,
  },
})

function StaticDialogFooter({
  children,
  classes,
  className: classNameProp,
  gutterTop,

  ...otherProps
}) {
  const className = classnames(
    classes.root,
    {
      [classes.gutterTop]: gutterTop,
    },
    classNameProp
  )

  return (
    <ScrollFrameFooter className={className} {...otherProps}>
      <CardActions className={classes.actions}>{children}</CardActions>
    </ScrollFrameFooter>
  )
}

StaticDialogFooter.propTypes = {
  gutterTop: PropTypes.bool,
}

import withStyles from "@material-ui/core/styles/withStyles"
import classnames from "classnames"

export default withStyles(styleSheet)(StaticDialogFooter)



// WEBPACK FOOTER //
// ../ui-kit/src/components/ui-StaticDialog/StaticDialogFooter.js